import React from 'react';
import { MainNav, SummaryReport, ReportNav, ReportButton } from './NavReport.style';

const NavReport = (props) => {
  
  return (
    <MainNav>
      <SummaryReport>
        <ReportButton onClick={() => props.actions.changeView('resumen')}>RESUMEN</ReportButton>
      </SummaryReport>
      <ReportNav>
        <ReportButton onClick={() => props.actions.changeView('percepcion')}>PERCEPCIÓN</ReportButton>
        <ReportButton onClick={() => props.actions.changeView('tendencia')}>TENDENCIA</ReportButton>
        <ReportButton onClick={() => props.actions.changeView('precio')}>PRECIO</ReportButton>
        <ReportButton onClick={() => props.actions.changeView('competencia')}>COMPETENCIA</ReportButton>
        {/* <ReportButton>GENERAR REPORTE</ReportButton> */}
      </ReportNav>
    </MainNav>
  );
}

export default NavReport;
